import { Route } from 'react-router-dom';
import { TargetShell } from '../identity/TargetShell';
import { BuddyDashboardPage } from './dashboard/BuddyPage';
import { BuddyUsagePage } from './pages/Usage';
import { BuddyFeedbackPage } from './pages/quality/Feedback';
import { BuddyFailedQueriesPage } from './pages/quality/FailedQueries';
import { BuddyRequestAuditPage } from './pages/quality/RequestAudit';
import { BuddyMonitorsPage } from './pages/monitors/Monitors';
import { BuddyMonitorDetailPage } from './pages/monitors/MonitorDetail';
import { BuddyOrganizationsPage } from './pages/setup/Organizations';
import { BuddySystemsPage } from './pages/setup/Systems';
import { BuddyTenantsPage } from './pages/setup/Tenants';
import { BuddyLimitsPage } from './pages/setup/Limits';
import { BuddyAccessPage } from './pages/setup/Access';
import { BuddyModelsPage } from './pages/setup/Models';
import { BuddyDbServersPage } from './pages/setup/DbServers';
import { BuddySkillsPage } from './pages/knowledge/Skills';
import { BuddyDocsPage } from './pages/knowledge/Docs';
import { BuddyTranslationsPage } from './pages/Translations';
import type { ReactElement } from 'react';

/** Path → page; every page runs inside the environment shell (`?target=`, only environments with a nyce.buddy). */
const PAGES: [string, () => ReactElement][] = [
  ['/buddy/usage', () => <BuddyUsagePage />],
  ['/buddy/feedback', () => <BuddyFeedbackPage />],
  ['/buddy/failed-queries', () => <BuddyFailedQueriesPage />],
  ['/buddy/requests', () => <BuddyRequestAuditPage />],
  ['/buddy/monitors', () => <BuddyMonitorsPage />],
  ['/buddy/monitors/:id', () => <BuddyMonitorDetailPage />],
  ['/buddy/organizations', () => <BuddyOrganizationsPage />],
  ['/buddy/systems', () => <BuddySystemsPage />],
  ['/buddy/tenants', () => <BuddyTenantsPage />],
  ['/buddy/access', () => <BuddyAccessPage />],
  ['/buddy/limits', () => <BuddyLimitsPage />],
  ['/buddy/models', () => <BuddyModelsPage />],
  ['/buddy/db-servers', () => <BuddyDbServersPage />],
  ['/buddy/skills', () => <BuddySkillsPage />],
  ['/buddy/docs', () => <BuddyDocsPage />],
  ['/buddy/translations', () => <BuddyTranslationsPage />],
];

/** The Buddy group's routes: the dashboard when the group may be opened, each page when its nav entry may be. */
export function buddyRoutes(canOpenGroup: boolean, allowed: (path: string) => boolean) {
  const nav = (path: string) => (path.startsWith('/buddy/monitors/') ? '/buddy/monitors' : path);
  return [
    canOpenGroup && <Route key="/buddy" path="/buddy" element={<BuddyDashboardPage />} />,
    ...PAGES.filter(([path]) => allowed(nav(path))).map(([path, page]) => (
      <Route key={path} path={path} element={<TargetShell service="buddy">{page()}</TargetShell>} />
    )),
  ];
}
